export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines-d9b736b15a996ef8283d55116986eb8d.svg";